"use client";

import useBoundStore from "@/store/bound-store";
import { shouldExcludeOneTimePurchases } from "@/utils/paid-feature-exclusion";

export interface OneTimePurchaseExclusionState {
  isOneTimePurchaseExcluded: boolean;
}

export function useOneTimePurchaseExclusion(): OneTimePurchaseExclusionState {
  const person = useBoundStore.use.person();

  return {
    isOneTimePurchaseExcluded: shouldExcludeOneTimePurchases(person),
  };
}
